var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.isMusic == 'true'?'music-T':'music-s'],on:{"click":_vm.stopMusic}},[(_vm.isMusic == 'true')?_c('van-icon',{attrs:{"name":"music"}}):_vm._e(),(_vm.isMusic != 'true')?_c('span',{staticClass:"inclined"}):_vm._e(),(_vm.isMusic != 'true')?_c('van-icon',{attrs:{"name":"music-o"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }